import { render, staticRenderFns } from "./QNoticesSidebar.vue?vue&type=template&id=1ad4b81e&scoped=true&"
import script from "./QNoticesSidebar.vue?vue&type=script&lang=ts&"
export * from "./QNoticesSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./QNoticesSidebar.vue?vue&type=style&index=0&id=1ad4b81e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad4b81e",
  null
  
)

export default component.exports